import React from "react";
import { useUserAndGameContext } from "../../contexts/UserAndGameContext";
import { useSuperPickemContext } from "./context/SuperPickemContext";
import JoinModal from "../GameModals/JoinGameModal/JoinModal";
import GameHeaderTemplate from "../PoolHeaderBar/GameHeaderTemplate";
import UserDash from "../UserDash/UserDash";
import EntryDropdown from "../GamePageComponents/Dropdowns/EntryDropdown";
import ConnectionError from "../ConnectionErrorPage/ConnectionError";
import GameNavBar from "../NavigationBars/GameNavigationBar/GameNavBar";
import GameHomePageVersionTwo from "../GameHomePage/GameHomePageVersionTwo";
import GameRulesPage from "../GameRulesPage/GameRulesPage";
import MembersPageContainerNew from "../MembersPage/MembersPageContainerNew";
import SponsorTab from "../SponsorTab/SponsorTab";
import ReferralsLeaderboard from "../ReferralsLeaderboard/ReferralsLeaderboardNew";
import PoolPartyPopUpModal from "../GameModals/PoolPartyPopUp/PoolPartyPopUpModal";
import SuperPickemBracketPage from "./MyBracket/SuperPickemBracketPage";
import MyPicks from "./MyPicks/MyPicks";
import SuperPickemPoolPicksAgnostic from "./PoolPicks/SuperPickemPoolPicksAgnostic";
import SuperPickemLeaderboardNew from "./Leaderboard/SuperPickemLeaderboardNew";
import UnsavedPicksModal from "../GameModals/UnsavedPicksModal/UnsavedPicksModal";
import SnackBar from "../GamePageComponents/SnackBar/SnackBar";
import InviteModal from "../GameModals/JoinGameModal/InviteModal";
import ChampDisplayTemplate from "../ChampionDisplay/ChampDisplayTemplate";
import TemplatedGameHomePage from "../NewGameHomePage/TemplatedGameHomePage";
import TemplatedSnackbarWithMenu from "../GamePageComponents/SnackBar/TemplatedSnackbarWithMenu";
import GameNavBarVersionTwo from "../NavigationBars/GameNavigationBar/GameNavBarVersionTwo";
import GameRulesPageNew from "../GameRulesPage/GameRulesPageNew";
import GameSwitchButtons from "../GamePageComponents/GameSwitchButtons/GameSwitchButtons";

const SuperPickemContainer = () => {
    const {
        page,
        gameData,
        isUserInThisPool,
        usersIndexesInThisPool,
        connectionError,
        joinOpen,
        setJoinOpen,
        popUpModalInfo,
        poolPartyPopUp,
        setPoolPartyPopUp,
        unsavedPicksModalOpen,
        snackBarInfo,
        inviteOpen,
        setInviteOpen,
        isGameOver,
        usersGameIdsInMasterPool,
        leaderboardData,
        masterPoolData,
        masterPoolId,
    } = useUserAndGameContext();

    const switchButtons = masterPoolData?.modalInfo?.gameSwitchButtons;

    const homePageInfo = gameData?.homePageInfo;

    const useOldNavBar = masterPoolData?.gameParameters?.useOldNavBar;

    const rulesPageInfo = gameData?.rulesPageInfo;

    return (
        <>
            <SnackBar snackBarInfo={snackBarInfo}/>

            {gameData?.gameSnackbarInfo && (
                <TemplatedSnackbarWithMenu />
            )}
            
            {!gameData?.gameSnackbarInfo && (
                <GameHeaderTemplate />
            )}

            {useOldNavBar && (
                <GameNavBar />
            )}

            {!useOldNavBar && (
                <GameNavBarVersionTwo />
            )}

            {isUserInThisPool && (
                <UserDash />
            )}

            {switchButtons && (
                <GameSwitchButtons />
            )}

            {(page === 'home' || page === 'leaderboard') && isGameOver && (
                <ChampDisplayTemplate
                    leaderboardData={leaderboardData}
                />
            )}

            {(usersGameIdsInMasterPool?.length > 1 || usersIndexesInThisPool?.length > 1) && (
                <EntryDropdown 
                    hideEntryDropdown={page !== 'my-picks' && page !== 'my-bracket'}
                />
            )}

            {page === 'home' && !homePageInfo && (
                <GameHomePageVersionTwo />
            )}

            {page === 'home' && homePageInfo && (
                <TemplatedGameHomePage />
            )}

            {page === 'my-bracket' && (
                <SuperPickemBracketPage />
            )}

            {page === 'bracket' && (
                <SuperPickemBracketPage />
            )}

            {page === 'my-picks' && (
                <MyPicks />
            )}

            {page === 'leaderboard' && (
                <SuperPickemLeaderboardNew />
            )}

            {page === 'pool-picks' && (
                <SuperPickemPoolPicksAgnostic />
            )}

            {page === 'rules' && !rulesPageInfo && (
                <GameRulesPage gameData={gameData} />
            )}

            {page === 'rules' && rulesPageInfo && (
                <GameRulesPageNew />
            )}

            {page === 'members' && (
                <MembersPageContainerNew />
            )}

            {page === 'sponsor' && (
                <SponsorTab gameData={gameData} />
            )}

            {page === 'referrals' && (
                <ReferralsLeaderboard />
            )}

            {poolPartyPopUp && (
                <PoolPartyPopUpModal
                    modalOpen={poolPartyPopUp}
                    setModalOpen={setPoolPartyPopUp}
                    modalInfo={popUpModalInfo}
                    masterPoolId={masterPoolId}
                />
            )}

            {unsavedPicksModalOpen && (
                <UnsavedPicksModal />
            )}

            {connectionError && (
                <ConnectionError />
            )}

            {joinOpen && (
                <JoinModal
                    joinOpen={joinOpen}
                    setJoinOpen={setJoinOpen}
                />
            )}

            {inviteOpen && (
                <InviteModal
                    open={inviteOpen}
                    setOpen={setInviteOpen}
                />
            )}
        </>
    );
};

export default SuperPickemContainer;
